import { ApiUrl2,UserToken,PrevilageId } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { fromJS } from 'immutable';

export default () => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'findby-group-id';

    const data = new FormData();
    data.append('group-id', PrevilageId );


    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : data
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });

    try{
        if(response.ok){
            var res = fromJS(await response.json());
            return res
        }
    }catch(ex){

    }
    
    return fromJS({
        'success': false
    })
};